import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const CaretUpIcon: React.FC<IconProps> = ({ color, size }) => {
  return (
    <Icon color={color} size={size}>
      <path d="M15.5 14.375C15.9922 14.375 16.2383 13.8008 15.8828 13.4453L12.3828 9.94531C12.1641 9.72656 11.8086 9.72656 11.5898 9.94531L8.08984 13.4453C7.73438 13.8008 7.98047 14.375 8.47266 14.375H15.5Z" />
    </Icon>
  );
};
